import Image from '../../Image';
import { NavType } from '../../interfaces';

import React, { ReactElement } from 'react';

import Logo from '../images/logo-footer.svg';
import Instagram from '../images/instagram.svg';
import Facebook from '../images/facebook.svg';
import Twitter from '../images/twitter.svg';
import Navbar from './Navbar';

interface LayoutType {
    children: ReactElement;
    navProps?: NavType;
}

export default function LayoutLogin({ children, navProps }: LayoutType): JSX.Element {
    return (
        <div className="mx-auto">
            <Navbar description={navProps?.description} title={navProps?.title} />
            <main>{children}</main>
            <footer className="hidden sm:block w-full bg-sm-blue-primary py-10">
                <div className="container mx-auto w-full text-white flex-none md:flex">
                    <div className="w-full md:w-1/3 p-2 md:px-6 text-center md:text-left">
                        <Image src={Logo} alt="SuperMatch Logo" />
                    </div>
                    <div className="p-5 md:px-6 w-full md:w-1/3 text-center">
                        <a href="mailto:contacto@supermatch.cl">contacto@supermatch.cl</a>
                    </div>
                    <div className="p-5 md:px-6 w-full md:w-1/3">
                        <div className="flex justify-center md:justify-end content-center space-x-4 items-end">
                            <div>
                                <Image src={Instagram} alt="Instagram" />
                            </div>
                            <div>
                                <Image src={Facebook} alt="Facebook" />
                            </div>
                            <div>
                                <Image src={Twitter} alt="Twitter" />
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
